import {FeatureFlagsEffects} from '../effects/feature-flags.effects'

export const uiEffects = [
    FeatureFlagsEffects
]